import React, { useEffect, useState, useRef } from "react";
import Blogimage from "./../assets/blogpage.webp"

const BlogHeader = () => {
  const text = "Our Blog";
  const [isVisible, setIsVisible] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    // Define keyframes dynamically
    const fadeInKeyframes = `
      @keyframes fadeInHeader {
        from {
          opacity: 0;
          transform: translateY(-20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;

    // Inject keyframes into the document head
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerHTML = fadeInKeyframes;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  useEffect(() => {
    // IntersectionObserver to detect when 30% of the header is visible
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (headerRef.current) observer.observe(headerRef.current);

    return () => {
      if (headerRef.current) observer.unobserve(headerRef.current);
    };
  }, []);

  return (
    <header ref={headerRef} style={styles.headerContainer}>
      <div style={styles.overlay}>
        <h1
          style={{
            ...styles.heading,
            opacity: isVisible ? 1 : 0,
            animation: isVisible ? "fadeInHeader 1s ease-out forwards" : "none",
          }}
        >
          {text}
        </h1>
        <p
          style={{
            ...styles.subText,
            opacity: isVisible ? 1 : 0,
            animation: isVisible ? "fadeInHeader 1.5s ease-out forwards" : "none",
          }}
        >
          Insights, stories, and updates from our team.
        </p>
      </div>
    </header>
  );
};

// Inline styles
const styles = {
  headerContainer: {
    width: "100vw",
    height: "50vh", // Half-screen height
    background: " rgb(92,14,20)",
    // background: "linear-gradient(180deg, rgba(92,14,20,1) 80%, rgba(0,0,0,1) 100%)", // Gradient background
    backgroundImage: `url(${Blogimage})`,
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "white",
    position: "relative",
  },
  overlay: {
    padding: "40px",
    borderRadius: "10px",
    maxWidth: "80%",
  },
  heading: {
    fontSize: "clamp(3rem, 6vw, 4.5rem)", // Responsive font size
    fontWeight: "bold",
    marginBottom: "10px",
  },
  subText: {
    fontSize: "1.5rem",
    marginTop: "10px",
  },
};

export default BlogHeader;
